import React from "react";
import ContactForm from "./ContactForm";

const QuotePage = () => {
  return (
    <main>
      <ContactForm />
    </main>
  );
};

export default QuotePage;